import React from 'react';
import { useLang, LANGUAGES } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ solid = false }) => {
  const { lang, setLang } = useLang();
  const colorClass = solid ? 'text-[#0b2545]' : 'text-white';
  const dividerClass = solid ? 'bg-[#0b2545]/30' : 'bg-white/40';

  return (
    <div className={`flex items-center gap-2 text-xs font-semibold tracking-[0.2em] ${colorClass}`}>
      {LANGUAGES.map((l, i) => (
        <React.Fragment key={l.code}>
          {i > 0 && <span className={`w-px h-3 ${dividerClass}`} aria-hidden />}
          <button
            type="button"
            onClick={() => setLang(l.code)}
            className={`transition-opacity hover:opacity-100 ${
              lang === l.code ? 'opacity-100' : 'opacity-55'
            }`}
            aria-pressed={lang === l.code}
            aria-label={`Switch to ${l.label}`}
          >
            {l.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
